export const en = {
    'button-cancel': 'Cancel'
};
